
export class AppSettings {

  //public static API_ENDPOINT = 'http://localhost:6064/api/';
  //public static API_ENDPOINT = 'http://102.134.136.2:6064/api/';
  public static API_ENDPOINT = 'http://sems.guc.ac.bw:6064/api/';

  public static GetCategory = 'GetCategory';
  public static GetAllCategory = 'GetAllCategory';
  public static GetCategoryByID = 'GetCategoryByID';
  public static CreateCategory = 'CreateCategory';
  public static UpdateCategory = 'UpdateCategory';
  public static DeleteCategory = 'DeleteCategory';

  public static GetProgramByID = 'GetProgramByID';
  public static GetAllProgram = 'GetAllProgram';
  public static CreateProgram = 'CreateProgram';
  public static UpdateProgram = 'UpdateProgram';
  public static DeleteProgram = 'DeleteProgram';

  public static GetModuleByID = 'GetModuleByID';
  public static GetModuleByProgramID = 'GetModuleByProgramID';
  public static GetAllModule = 'GetAllModule';
  public static CreateModule = 'CreateModule';
  public static UpdateModule = 'UpdateModule';
  public static DeleteModule = 'DeleteModule';

  public static GetSponserByID = 'GetSponserByID';
  public static GetAllSponser = 'GetAllSponsers';
  public static CreateSponser = 'CreateSponser';
  public static UpdateSponser = 'UpdateSponser';
  public static DeleteSponser = 'DeleteSponser';

  public static GetOrganisationByID = 'GetOrganisationByID';
  public static GetAllOrganisation = 'GetAllOrganisation';
  public static CreateOrganisation = 'CreateOrganisation';
  public static UpdateOrganisation = 'UpdateOrganisation';
  public static DeleteOrganisation = 'DeleteOrganisation';

  public static GetInstitutionByID = 'GetInstitutionByID';
  public static GetAllInstitution = 'GetAllInstitution';
  public static CreateInstitution = 'CreateInstitution';
  public static UpdateInstitution = 'UpdateInstitution';
  public static DeleteInstitution = 'DeleteInstitution';

  public static GetApplicationByID = 'GetApplicationByID';
  public static GetAllApplication = 'GetAllApplication';
  public static GetApplicationCode = 'GetApplicationCode';
  public static CreateApplication = 'CreateApplication';
  public static UpdateApplication = 'UpdateApplication';

  public static GetGradeByID = 'GetGradeByID';
  public static GetAllGrade = 'GetAllGrade';
  public static CreateGrade = 'CreateGrade';
  public static UpdateGrade = 'UpdateGrade';
  public static UpdateGradeByParam = 'UpdateGradeByParam';
  public static DeleteGrade = 'DeleteGrade';

  public static GetSubjectByID = 'GetSubjectByID';
  public static GetAllSubject = 'GetAllSubject';
  public static GetSubjectByParam = 'GetSubjectByParam';
  public static CreateSubject = 'CreateSubject';
  public static UpdateSubject = 'UpdateSubject';
  public static DeleteSubject = 'DeleteSubject';

  public static GetAllBatch = 'GetAllBatch';
  public static GetBatchByID = 'GetBatchByID';
  public static GetBatchByProgramID = 'GetBatchByProgramID';
  public static GetBatchByParam = 'GetBatchByParam';
  public static CreateBatch = 'CreateBatch';
  public static UpdateBatch = 'UpdateBatch';
  public static DeleteBatch = 'DeleteBatch';

  public static GetUserData = 'GetUserByParam';
  public static GetAllUsers = 'GetAllUsers';
  public static Createuser = 'CreateUser';
  public static GetUserByID = 'GetUserByID';
  public static UpdateUser = 'UpdateUser';

  public static GetAllStudents = 'GetAllStudents';
  public static GetStudentsByParam = 'GetStudentsByParam';
  public static GetStudentsByBatchID = 'GetStudentsByBatchID';
  public static CreateStudent = 'CreateStudent';
  public static UpdateStudent = 'UpdateStudent';
  public static GetStudentByID = 'GetStudentByID';

  public static GetAllTempStudents = 'GetAllTempStudents';
  public static StudentToProduction = 'StudentToProduction';

  public static GetAllTempExams = 'GetAllTempExams';
  public static GetExamByParam = 'GetExamByParam';
  public static CreateExam = 'CreateExam';
  public static CreateExamData = 'CreateExamData';
  public static DeleteExam = 'DeleteExam';

  public static ExamToProduction = 'ExamToProduction';
  public static GetAllExams = 'GetAllExams';
  public static GetExamByEnrollmentNo = 'GetExamByEnrollmentNo';

  public static GetAllRole = 'GetAllRole';
  public static CreateRole = 'CreateRole';

  public static UpdateDecisionByParam = 'UpdateDecisionByParam';

  public static GetAllPosition = 'GetAllPosition';
  public static UploadStudentExcel = 'UploadStudentExcel';
  public static UploadMarksExcel = 'UploadMarksExcel';

}
